// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CraeteCustomerFormCmp from "./CraeteCustomerFormCmp.bs.js";
import * as CreateCustomerAssetsManager from "../assets/CreateCustomerAssetsManager.bs.js";

CreateCustomerAssetsManager.importCss(undefined);

function CreateCustomerComponent(Props) {
  var phone_number = Props.phone_number;
  return React.createElement("div", {
              className: "c-create-customer-container"
            }, React.createElement(CraeteCustomerFormCmp.make, {
                  phone_number: phone_number
                }));
}

var make = CreateCustomerComponent;

export {
  make ,
  
}
/*  Not a pure module */
